import {
    DELETE_DEPARTMENT_RANDOM_DATE_LOG,
    DELETE_DEPARTMENT_RANDOM_DATE_LOG_FAIL,
    DELETE_DEPARTMENT_RANDOM_DATE_LOG_SUCCESS,
    DEPARTMENT_RANDOM_DATE_LOG_CREATE,
    DEPARTMENT_RANDOM_DATE_LOG_CREATE_FAIL,
    DEPARTMENT_RANDOM_DATE_LOG_CREATE_SUCCESS,
    GET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS,
    GET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS_FAIL,
    GET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS_SUCCESS,
    RESET,
    RESET_DEPARTMENT_RANDOM_DATE_LOG_CREATE,
    RESET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS,
    UPDATE_DEPARTMENT_RANDOM_DATE_LOG,
    UPDATE_DEPARTMENT_RANDOM_DATE_LOG_FAIL,
    UPDATE_DEPARTMENT_RANDOM_DATE_LOG_SUCCESS,
} from "./actionsTypes";

const initialState = {
    departmentRandomDateLogList: [],
    departmentRandomDateLogDetails: {},
    createResult: {},
    deleteResult: {},
    loading: false,
    detailsLoading:false,
    loadingCreate: false,
    error: {
        message: "",
    },
};

const DepartmentRandomDateLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case DEPARTMENT_RANDOM_DATE_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case DEPARTMENT_RANDOM_DATE_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case DEPARTMENT_RANDOM_DATE_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        case GET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS:
            state = { ...state, detailsLoading: true, departmentRandomDateLogDetails: {} };
            break;
        case GET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS_SUCCESS:
            state = { ...state, departmentRandomDateLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        case UPDATE_DEPARTMENT_RANDOM_DATE_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_DEPARTMENT_RANDOM_DATE_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_DEPARTMENT_RANDOM_DATE_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case DELETE_DEPARTMENT_RANDOM_DATE_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_DEPARTMENT_RANDOM_DATE_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_DEPARTMENT_RANDOM_DATE_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;
        case RESET_DEPARTMENT_RANDOM_DATE_LOG_DETAILS:
            state = { ...state, departmentRandomDateLogDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, departmentRandomDateLogList: [], createResult: {} };
            break;
        case RESET_DEPARTMENT_RANDOM_DATE_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default DepartmentRandomDateLogReducer;